import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store';
Vue.use(VueRouter);

//router setup
import routes from "./routers";

//configure router
const router = new VueRouter({
    mode: "history",
    routes, //short for routes: routes
    scrollBehavior: to => {
        if (to.hash) 
            return {selector: to.hash};
        else
            return {x: 0, y: 0};
    },
    linkActiveClass: "nav-item active"
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index){
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if(!subsequentMiddleware)
        return context.next;

    return (...parameters) => {
        // Run the dafult Vue Router 'next()' callback first.
        if (parameters.length > 0) {
            return context.next(...parameters);
        }
        // Then run the subsequent Middleware with a new
        // 'nextMiddleware() callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        return subsequentMiddleware({...context, next: nextMiddleware});
    };
}

router.beforeEach((to, from, next) => {
    if(to.meta.middleware){
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
        const context = {from, next, to, router};
        const nextMiddleware = nextFactory(context, middleware, 1);
        return middleware[0]({...context, next: nextMiddleware});
    }
    return next();
});

export default router;